import { Flex, Box } from '@mantine/core'
import { clsx } from 'clsx'

import { useTranslation } from '@flecto/translations'
import { BoxCollapsible } from '@flecto/ui'

import { useRows } from './hooks/useRows'
import classes from './styles.module.css'

export const OverviewCard = () => {
  const { rows } = useRows()
  const { t } = useTranslation('saas', { keyPrefix: 'booking_value' })

  return (
    <BoxCollapsible title={t('title')}>
      {rows.map((item, idx) => (
        <Flex
          key={`item${idx}`}
          justify='space-between'
          align='center'
          w='100%'
          className={clsx(classes.item, item.classes)}
        >
          <Box>{item.label}</Box>
          <Box>{item.element}</Box>
        </Flex>
      ))}
    </BoxCollapsible>
  )
}
